import { useThemeStore } from "@stores/theme.store";
import { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "@assets/images/logo-sipiat.jpg";
import { linkPage } from "@utils/router";
import {
  PopupConfirm,
  PopupCustom,
  PopupSuccess,
} from "@components/general/popup";
import Cookies from "js-cookie";
import { Button, Form, message, Select } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";

import MaleLogo from "@assets/images/avatar.png";
import FemaleLogo from "@assets/images/avatar-female.png";
import { androidSetupBiometric } from "@utils/android";
import { useBiometricStore } from "@stores/biometric.store";
import { FaAngleRight, FaFingerprint } from "react-icons/fa";
import { AccountService } from "@services/account.service";
import { formatPhoneNumber } from "@utils/helper";

export const ProfilePage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar, popupStatus, setPopupStatus } = useThemeStore(
    (state) => state,
  );
  const [isBiometric, setIsBiometric] = useState<boolean>(false);
  const { isActiveBiometric } = useBiometricStore((state) => state);
  const [popupStudent, setPopupStudent] = useState<boolean>(false);
  const [popupSuccess, setPopupSuccess] = useState<boolean>(false);
  const [studentNis, setStudentNis] = useState<string>("");
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  // const [popupLogout, setPopupLogout] = useState<boolean>(false);

  const { data: dataNis, refetch: refetchNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "---";
  const gender = dataNis?.data?.gender ?? "";

  const { data, isPending, refetch } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
    queryFn: () => SchoolService.studentBiography(nis),
  });

  const { data: students } = useQuery({
    queryKey: [AccountService.queries.GET_ACCOUNT_STUDENTS],
    queryFn: AccountService.students,
  });

  const { mutate, isPending: isPendingMutate } = useMutation({
    mutationFn: AccountService.changeStudent,
    onSuccess: (response) => {
      if (response.success) {
        setPopupStudent(false);
        setPopupSuccess(true);
      } else {
        setShowMessage(true);
        setShowMessageText(response.message ?? "Internal Error");
      }
    },
    onError: (error: any) => {
      setShowMessage(true);
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  const onChnageStudent = () => {
    mutate(studentNis);
  };

  const onFinishChangeStudent = () => {
    refetchNis();
    refetch();
    setPopupSuccess(false);
  };

  useEffect(() => {
    setHeader({
      buttonBack: false,
      filter: false,
      title: "Profil Anda",
      // buttonLogout: true,
    });
    setAppBar({ title: "Profil", show: true, leading: "back" });
    setStudentNis(nis);
  }, [setHeader, setAppBar, setStudentNis, students]);

  useEffect(() => {
    const skip = localStorage.getItem("is-biometric");
    setIsBiometric(skip === "true");
  }, []);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: "error",
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText]);

  const onSetupBiometric = () => {
    const status = localStorage.getItem("status-biometric");
    if (status === "register") {
      androidSetupBiometric("remove");
    } else {
      androidSetupBiometric("register");
    }
  };

  const onLogout = () => {
    Cookies.remove("token");
    Cookies.remove("redirect");
    // localStorage.setItem("nis", "");
    navigate("/auth/login");
    setPopupStatus(false);
    setAppBar({ show: false });
  };

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pb-20">
        {/* <div className="tw-bg-other-100 tw-rounded-md card-body">
          <div className="tw-mb-4 tw-mt-5 tw-text-center">
            <img
              src={
                isPending
                  ? MaleLogo
                  : data?.data?.foto === null || data?.data?.foto === ""
                  ? gender === "Pria" || gender === "PRIA" || gender === ""
                    ? MaleLogo
                    : FemaleLogo
                  : `https://sipiat2.pesantrenalirsyad2.org/assets/fotosiswa/${data?.data?.foto}`
              }
              alt=""
              className="tw-w-24 tw-h-24 tw-object-cover tw-rounded-full tw-aling-middle"
              style={{ marginTop: "-25px" }}
            />
          </div>
          <div className="tw-mb-4 tw-text-xl tw-text-center">
            {dataNis?.data?.nama}
          </div>
          <div className="tw-m-auto tw-w-3/4">
            <div className="tw-mb-4 tw-text-base tw-font-normal tw-text-other-600">
              <div
                style={{
                  display: "flex",
                  flexFlow: "column",
                }}
              >
                <div className="tw-mb-4 tw-flex tw-items-center tw-text-other-600 tw-font-normal">
                  <div className="tw-w-1/3 tw-text-sm">NIS</div>
                  <div className="tw-ms-2 tw-text-sm">: {nis ?? "----"}</div>
                </div>
                <div className="tw-mb-4 tw-flex tw-items-center tw-text-other-600 tw-font-normal">
                  <div className="tw-w-1/3 tw-text-sm">Kelas</div>
                  <div className="tw-ms-2 tw-text-sm">
                    : {dataNis?.data?.kelas ?? "----"}
                  </div>
                </div>
                <div className="tw-mb-4 tw-flex tw-items-center tw-text-other-600 tw-font-normal">
                  <div className="tw-w-1/3 tw-text-sm">No. Telp</div>
                  <div className="tw-ms-2 tw-text-sm">
                    :{" "}
                    {data?.data?.telephon === ""
                      ? "----"
                      : data?.data?.telephon}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="tw-mb-4 tw-flex tw-items-center tw-rounded-md tw-bg-other-100 tw-text-center card-body">
          <div className="tw-me-4">
            <img
              src={
                isPending
                  ? MaleLogo
                  : data?.data?.foto === null || data?.data?.foto === ""
                    ? gender === "Pria" || gender === "PRIA" || gender === ""
                      ? MaleLogo
                      : FemaleLogo
                    : `https://sipiat2.pesantrenalirsyad2.org/assets/fotosiswa/${data?.data?.foto}`
              }
              alt=""
              className="tw-w-[60px] tw-h-[60px] tw-object-cover tw-rounded-full tw-aling-middle"
            />
          </div>
          <div className="tw-text-left">
            <div className="tw-text-lg tw-font-medium tw-text-primary">
              {data?.data?.namasiswa ?? "---"}
            </div>
            <div className="tw-text-sm tw-text-neutral-text-2">
              Kelas {data?.data?.kelas}
            </div>
          </div>
        </div>

        <div className="tw-bg-other-100 tw-rounded-lg tw-mt-4 card-body">
          <div className="tw-text-primary-hg tw-text-xs tw-mb-2">
            Informasi Asrama
          </div>
          <div className="tw-mb-2 tw-flex tw-items-center tw-text-other-600 tw-font-normal">
            <div className="tw-w-2/5 tw-text-sm">Jadwal Telpon</div>
            <div className="tw-ms-2 tw-text-sm">
              : {data?.data?.hari ?? "----"}, Pukul{" "}
              {data?.data?.jamMulai ?? "----"} -{" "}
              {data?.data?.jamSelesai ?? "----"} WIB
            </div>
          </div>
          <div className="tw-flex tw-items-center tw-text-other-600 tw-font-normal">
            <div className="tw-w-2/5 tw-text-sm">No. Telpon Kamar</div>
            <div className="tw-ms-2 tw-text-sm">
              :{" "}
              {data?.data?.teleponKamar === "" ||
              data?.data?.teleponKamar === null
                ? "----"
                : formatPhoneNumber(data?.data?.teleponKamar)}
            </div>
          </div>
        </div>

        <div className="tw-bg-other-100 tw-rounded-lg tw-mt-4 card-body">
          <Button
            type="primary"
            className="tw-h-9 tw-w-full bg-gradient focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
            onClick={() => setPopupStudent(true)}
          >
            Ganti Siswa
          </Button>

          <Button
            type="primary"
            className="tw-mt-3 tw-h-9 tw-w-full bg-gradient focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
            onClick={() => navigate(linkPage.SETTING_UPDATE_ACCOUNT)}
          >
            Edit Data
          </Button>

          <Button
            type="primary"
            className="tw-mt-3 tw-h-9 tw-w-full bg-gradient focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
            onClick={() =>
              navigate(linkPage.SETTING_CHANGE_PASSWORD, {
                state: dataNis?.data,
              })
            }
          >
            Ubah Password
          </Button>

          <Button
            type="primary"
            className="tw-h-9 tw-w-full tw-bg-red-700 tw-mt-3 focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-red-700 hover:tw-border-red-700"
            onClick={() => setPopupStatus(true)}
          >
            Keluar
          </Button>

          {isBiometric ? (
            <div
              className="tw-list-group-item tw-d-flex tw-px-0 tw-py-3 tw-border-[rgba(0,0,0,0.05)] tw-cursor-pointer"
              onClick={onSetupBiometric}
            >
              <div
                className={`tw-rounded-sm tw-w-8 tw-h-8 tw-d-flex tw-flex-none tw-my-auto ${
                  isActiveBiometric ? "tw-bg-teal-dark" : "tw-bg-gray-dark"
                }`}
              >
                <FaFingerprint className="tw-m-auto" />
              </div>
              <div className="tw-grow tw-mx-3 tw-my-auto tw-d-flex tw-flex-column tw-w-[calc(100vw-140px)]">
                <span className="tw-font-medium tw-text-sm tw-truncate">
                  {isActiveBiometric
                    ? "Login Biometrik Aktif"
                    : "Aktifkan Login Biometrik"}
                </span>
                <strong className="tw-font-medium tw-text-[11px] tw-text-[#adb5bd] tw-truncate">
                  {isActiveBiometric
                    ? "Login cepat biometrik sudah aktif"
                    : "Fitur login cepat dengan biometrik"}
                </strong>
              </div>
              <div className="tw-my-auto">
                <FaAngleRight className="" size={10} />
              </div>
            </div>
          ) : null}
        </div>
      </div>

      <PopupCustom
        open={popupStudent}
        title="Ganti Siswa"
        onCancel={() => setPopupStudent(false)}
      >
        <Form
          className=""
          autoComplete="off"
          onFinish={() => onChnageStudent()}
        >
          <div className="tw-text-xs tw-mb-1">Pilih Siswa</div>
          <Select
            className="tw-text-base tw-mb-6"
            placeholder="Pilih Siswa"
            defaultValue={studentNis}
            style={{ width: "100%" }}
            allowClear
            onChange={(e) => setStudentNis(e)}
            options={students?.data?.map((item: any) => {
              return {
                value: item.nis,
                label: item.nama + " - " + item.nis,
              };
            })}
          ></Select>

          <Button
            type="primary"
            htmlType="submit"
            loading={isPendingMutate}
            className="tw-h-9 tw-w-full bg-gradient focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
          >
            Simpan
          </Button>
        </Form>
      </PopupCustom>

      <PopupConfirm
        open={popupStatus}
        title={dataNis?.data?.nama ?? "-"}
        message="Yakin ingin keluar dari Sipond?"
        textConfirm="Keluar"
        textCancel="Batalkan"
        onConfirm={onLogout}
        onCancel={() => setPopupStatus(false)}
      />

      <PopupSuccess
        open={popupSuccess}
        title="Berhasil"
        message="Ganti siswa behasil, sekarang semua data siswa sudah berubah"
        textConfirm="Kembali"
        onConfirm={() => {
          onFinishChangeStudent();
        }}
      />
    </>
  );
};
